import { Button } from '@/components/ui/button';
import { FileQuestionMark } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface AutoContinuationPromptProps {
  attempts?: number;
  maxAttempts?: number;
  onContinue?: () => void;
}

export function AutoContinuationPrompt({
  attempts,
  maxAttempts,
  onContinue,
}: AutoContinuationPromptProps) {
  const { t } = useTranslation('prince');

  return (
    <div className="mt-4 rounded-lg border bg-gray-light-5 p-3">
      <div className="flex items-start gap-3">
        <FileQuestionMark className="mt-0.5 h-4 w-4" />
        <div className="flex-1 text-sm">
          <p className="font-medium">{t('messages.autoContinuation.promptTitle')}</p>
          <p className="mt-1 text-xs">
            {typeof attempts === 'number' && typeof maxAttempts === 'number'
              ? t('messages.autoContinuation.promptDescriptionWithLimit', {
                  attempts,
                  maxAttempts,
                })
              : typeof attempts === 'number'
                ? t('messages.autoContinuation.promptDescriptionAttemptsOnly', { attempts })
                : typeof maxAttempts === 'number'
                  ? t('messages.autoContinuation.promptDescriptionLimitOnly', { maxAttempts })
                  : t('messages.autoContinuation.promptDescriptionGeneric')}
          </p>
        </div>
        {onContinue && (
          <Button
            size="sm"
            className="color-white gap-2 bg-gradient-to-r from-[#043764] via-[#193446] to-[#22333B] border-none hover:opacity-90 align-end justify-end"
            onClick={onContinue}
            data-testid="auto-continue-button"
          >
            {t('messages.autoContinuation.continueButton')}
          </Button>
        )}
      </div>
    </div>
  );
}
